import {
  Event,
  Identifiable,
  List,
  Milestone,
  Project,
  resource,
  Resource,
  Task,
  Zone,
} from "@planzone/dto";

type LogType =
  | "PLANZONE"
  | "ZONE"
  | "PROJECT"
  | "ACTIVITY"
  | "TASK"
  | "EVENT"
  | "MILESTONE"
  | "RESOURCE"
  | "UNAVAILABILITY"
  | "COST_PROFILE"
  | "PLANZONE_RESOURCE"
  | "PROJECT_RESOURCE"
  | "PROJECT_RESOURCE_GROUP"
  | "PROJECT_STATUS"
  | "STATUS"
  | "STRATEGIC_AXES"
  | "TIME_RECORD"
  | "AUTHENTICATION"
  | "EMAIL"
  | "NOTIFICATION"
  | "PORTFOLIO";

type Log = {
  createdDate: string;
  content: string;
  attributes: {
    data?: string;
    target?: string;
    uuid?: string;
    parent?: string;
  };
  logType: LogType;
  author: Identifiable<Resource>;
  zone?: Identifiable<Zone>;
  project?: Identifiable<Project>;
  list?: Identifiable<List>;
  task?: Identifiable<Task>;
  event?: Identifiable<Event>;
  milestone?: Identifiable<Milestone>;
};

const log: Log = {
  createdDate: "",
  content: "",
  attributes: {
    data: "",
    target: "",
    uuid: "",
  },
  logType: "PLANZONE",
  author: { ...resource, uuid: "" },
};

const logTypes: LogType[] = [
  "PLANZONE",
  "ZONE",
  "PROJECT",
  "ACTIVITY",
  "TASK",
  "EVENT",
  "MILESTONE",
  "RESOURCE",
  "UNAVAILABILITY",
  "COST_PROFILE",
  "PLANZONE_RESOURCE",
  "PROJECT_RESOURCE",
  "PROJECT_RESOURCE_GROUP",
  "PROJECT_STATUS",
  "STATUS",
  "STRATEGIC_AXES",
  "TIME_RECORD",
  "AUTHENTICATION",
  "EMAIL",
  "NOTIFICATION",
  "PORTFOLIO",
];

export type { Log, LogType };

export { logTypes, log };
